export default "__VITE_ASSET__DNCzGoiT__"